import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import api from "../../api/http";
import "../../styles/admin/DespreManager.css"; // ✅ NOU (clase unice)

const DespreManager = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // form despre
  const [showAboutForm, setShowAboutForm] = useState(false);
  const [selectedAbout, setSelectedAbout] = useState(null);
  const [aboutForm, setAboutForm] = useState({ titlu: "" });

  // form detalii
  const [showDetailForm, setShowDetailForm] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [detailForm, setDetailForm] = useState({ despre: "", detali: "" });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [saving, setSaving] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  // ✅ DOAR sessionStorage, conform interceptorului tău
  const isLoggedIn = Boolean(sessionStorage.getItem("access"));

  // ✅ auto-dismiss success message
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(""), 5000);
    return () => clearTimeout(t);
  }, [message]);

  const parseApiError = (err) => {
    const data = err?.response?.data;
    if (!data) return err?.message || "A apărut o eroare.";
    if (typeof data === "string") return data;
    if (Array.isArray(data)) return data[0] || "A apărut o eroare.";
    if (data.detail) return data.detail;

    if (typeof data === "object") {
      const k = Object.keys(data)[0];
      const v = data[k];
      if (Array.isArray(v)) return v[0];
      if (typeof v === "string") return v;
    }
    return "A apărut o eroare.";
  };

  const normalizeList = (data) => {
    if (Array.isArray(data?.results)) return data.results;
    if (Array.isArray(data)) return data;
    return [];
  };

  const refresh = async () => {
    setError("");
    try {
      const res = await api.get("/about/despre/");
      const list = normalizeList(res.data);
      setItems(list);
    } catch (err) {
      setItems([]);
      setError(parseApiError(err));
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      await refresh();
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --------- ABOUT (Despre) ----------
  const openAddAbout = () => {
    setMessage("");
    setError("");
    setSelectedAbout(null);
    setAboutForm({ titlu: "" });
    setShowAboutForm(true);
  };

  const openEditAbout = (about) => {
    setMessage("");
    setError("");
    setSelectedAbout(about);
    setAboutForm({ titlu: about?.titlu || "" });
    setShowAboutForm(true);
  };

  const closeAboutForm = () => {
    if (saving) return;
    setShowAboutForm(false);
    setSelectedAbout(null);
    setAboutForm({ titlu: "" });
  };

  const submitAbout = async () => {
    setMessage("");
    setError("");

    const titlu = aboutForm.titlu.trim();
    if (!titlu) {
      setError("Titlul este obligatoriu.");
      return;
    }

    setSaving(true);
    try {
      if (selectedAbout) {
        await api.put(`/about/despre/${selectedAbout.id}/`, { titlu });
        setMessage("Actualizat cu succes.");
      } else {
        await api.post(`/about/despre/`, { titlu });
        setMessage("Adăugat cu succes.");
      }

      closeAboutForm();
      await refresh();
    } catch (err) {
      setError(parseApiError(err));
    } finally {
      setSaving(false);
    }
  };

  const deleteAbout = async (id) => {
    setMessage("");
    setError("");

    const ok = window.confirm("Sigur vrei să ștergi acest element?");
    if (!ok) return;

    setDeletingId(id);
    try {
      await api.delete(`/about/despre/${id}/`);
      setMessage("Șters cu succes.");
      await refresh();
    } catch (err) {
      setError(parseApiError(err));
    } finally {
      setDeletingId(null);
    }
  };

  // --------- DETAILS (Detalii) ----------
  const openAddDetail = () => {
    setMessage("");
    setError("");
    setSelectedDetail(null);
    setDetailForm({ despre: "", detali: "" });
    setShowDetailForm(true);
  };

  const openEditDetail = (detail) => {
    setMessage("");
    setError("");
    setSelectedDetail(detail);
    setDetailForm({
      despre: String(detail?.despre || detail?.despre_id || ""),
      detali: detail?.detali || "",
    });
    setShowDetailForm(true);
  };

  const closeDetailForm = () => {
    if (saving) return;
    setShowDetailForm(false);
    setSelectedDetail(null);
    setDetailForm({ despre: "", detali: "" });
  };

  const submitDetail = async () => {
    setMessage("");
    setError("");

    const despre = String(detailForm.despre || "").trim();
    const detali = String(detailForm.detali || "").trim();

    if (!despre) {
      setError("Selectează 'Despre'.");
      return;
    }
    if (!detali) {
      setError("Detaliul este obligatoriu.");
      return;
    }

    setSaving(true);
    try {
      if (selectedDetail) {
        await api.put(`/about/details/${selectedDetail.id}`, { despre, detali });
        setMessage("Detaliu actualizat.");
      } else {
        await api.post(`/about/details`, { despre, detali });
        setMessage("Detaliu adăugat.");
      }

      closeDetailForm();
      await refresh();
    } catch (err) {
      setError(parseApiError(err));
    } finally {
      setSaving(false);
    }
  };

  const deleteDetail = async (detailId) => {
    setMessage("");
    setError("");

    const ok = window.confirm("Sigur vrei să ștergi acest detaliu?");
    if (!ok) return;

    setDeletingId(detailId);
    try {
      await api.delete(`/about/details/${detailId}`);
      setMessage("Detaliu șters.");
      await refresh();
    } catch (err) {
      setError(parseApiError(err));
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="sr-despreMng">

      {message && <p className="sr-despreMng__msg sr-despreMng__msg--ok">{message}</p>}
      {error && <p className="sr-despreMng__msg sr-despreMng__msg--err">{error}</p>}

      {isLoggedIn && (
        <div className="sr-despreMng__topActions">
          <button className="sr-despreMng__btn sr-despreMng__btn--primary" onClick={openAddAbout} disabled={saving}>
            Adaugă titlu nou
          </button>
          <button className="sr-despreMng__btn sr-despreMng__btn--primary" onClick={openAddDetail} disabled={saving}>
            Adaugă detaliu nou
          </button>
        </div>
      )}

      {showAboutForm && (
        <div className="sr-despreMng__formCard">
          <form onSubmit={(e) => e.preventDefault()}>
            <textarea
              className="sr-despreMng__textarea"
              placeholder="Titlu"
              value={aboutForm.titlu}
              onChange={(e) => setAboutForm({ titlu: e.target.value })}
              disabled={saving}
            />
            <div className="sr-despreMng__formActions">
              <button className="sr-despreMng__btn sr-despreMng__btn--primary" type="button" onClick={submitAbout} disabled={saving}>
                {saving ? "Se salvează..." : selectedAbout ? "Actualizează" : "Adaugă"}
              </button>
              <button className="sr-despreMng__btn sr-despreMng__btn--danger" type="button" onClick={closeAboutForm} disabled={saving}>
                Close
              </button>
            </div>
          </form>
        </div>
      )}

      {showDetailForm && (
        <div className="sr-despreMng__formCard">
          <form onSubmit={(e) => e.preventDefault()}>
            <select
              className="sr-despreMng__select"
              value={detailForm.despre}
              onChange={(e) => setDetailForm((p) => ({ ...p, despre: e.target.value }))}
              disabled={saving}
            >
              <option value="">Selectează titlul (Despre)</option>
              {items.map((it) => (
                <option key={it.id} value={it.id}>
                  {it.titlu}
                </option>
              ))}
            </select>

            <textarea
              className="sr-despreMng__textarea"
              placeholder="Detaliu"
              value={detailForm.detali}
              onChange={(e) => setDetailForm((p) => ({ ...p, detali: e.target.value }))}
              disabled={saving}
            />

            <div className="sr-despreMng__formActions">
              <button className="sr-despreMng__btn sr-despreMng__btn--primary" type="button" onClick={submitDetail} disabled={saving}>
                {saving ? "Se salvează..." : selectedDetail ? "Actualizează" : "Adaugă"}
              </button>
              <button className="sr-despreMng__btn sr-despreMng__btn--danger" type="button" onClick={closeDetailForm} disabled={saving}>
                Close
              </button>
            </div>
          </form>
        </div>
      )}

      {loading ? (
        <p className="sr-despreMng__loading">Loading...</p>
      ) : (
        items.map((about, index) => (
          <div className="sr-despreMng__item" key={about.id}>
            <div className="sr-despreMng__itemHeader">
              <h3 className="sr-despreMng__itemTitle">{`${index + 1}. ${about.titlu}`}</h3>

              {isLoggedIn && (
                <div className="sr-despreMng__itemActions">
                  <button
                    className="sr-despreMng__iconBtn sr-despreMng__iconBtn--danger"
                    onClick={() => deleteAbout(about.id)}
                    disabled={saving || deletingId === about.id}
                    title="Șterge titlul"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>

                  <button
                    className="sr-despreMng__iconBtn sr-despreMng__iconBtn--ok"
                    onClick={() => openEditAbout(about)}
                    disabled={saving}
                    title="Editează titlul"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faSyncAlt} />
                  </button>
                </div>
              )}
            </div>

            {Array.isArray(about.detalii) && about.detalii.length > 0 ? (
              <ol className="sr-despreMng__list">
                {about.detalii.map((d, idx) => (
                  <li className="sr-despreMng__listItem" key={d.id}>
                    <span className="sr-despreMng__counter">{`${idx + 1})`}</span>
                    <span className="sr-despreMng__text">{d.detali}</span>

                    {isLoggedIn && (
                      <div className="sr-despreMng__detailActions">
                        <button
                          className="sr-despreMng__iconBtn sr-despreMng__iconBtn--danger"
                          onClick={() => deleteDetail(d.id)}
                          disabled={saving || deletingId === d.id}
                          title="Șterge detaliu"
                          type="button"
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </button>

                        <button
                          className="sr-despreMng__iconBtn sr-despreMng__iconBtn--ok"
                          onClick={() => openEditDetail(d)}
                          disabled={saving || deletingId === d.id}
                          title="Editează detaliu"
                          type="button"
                        >
                          <FontAwesomeIcon icon={faSyncAlt} />
                        </button>
                      </div>
                    )}
                  </li>
                ))}
              </ol>
            ) : (
              <p className="sr-despreMng__empty">Nu există detalii.</p>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default DespreManager;